import { render, staticRenderFns } from "./SelectBereiche.vue?vue&type=template&id=65b0ddc6"
import script from "./SelectBereiche.vue?vue&type=script&lang=js"
export * from "./SelectBereiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports